/** Settings › Connections: apps, AI tools and the recording folder. */
export default {
  needAttention: { other: "{count} need attention" },
  pageTitleNeedsYou: {
    one: "{count} connection needs you.",
    other: "{count} connections need you.",
  },
  pageTitleYours: "Your connections.",
  pageTitleAllConnected: "Everything is connected.",
  pageLineApps: {
    one: "Denker can work with {count} app.",
    other: "Denker can work with {count} apps.",
  },
  appsTitle: "Apps",
  addApp: "Add an app",

  appNotConnected: "Not connected",
  appsUnavailable: "App connections unavailable.",
  status: "Status",
  connectedSince: "Connected since",
  connect: "Connect",
  opensBrowserToSignIn: "Opens your browser to sign in",
  connectOpensBrowser: "Connect opens your browser to sign in.",
  connecting: "Connecting…",
  connected: "Connected",
  reconnect: "Reconnect",
  disconnect: "Disconnect",
  disconnectApp: "Disconnect {name}",
  disconnectAppQuestion: "Disconnect {name}?",
  disconnectAppDescription: "Denker will no longer be able to use this app.",
  searchApps: "Search apps",
  searchAppsPlaceholder: "Search apps…",
  loadingApps: "Loading apps…",
  noAppsFound: "No apps found.",
  loadMore: "Load more",

  runtimeNotInstalled: "Not installed",
  runtimeNotSignedIn: "Not signed in",
  runtimeUpdateAvailable: "Update available",
  runtimeReady: "Ready",
  runtimeSignInUnknown: "Sign-in status unknown",
  toolTitleNotInstalled: "{name}: not installed.",
  toolTitleNotSignedIn: "{name}: not signed in.",
  toolTitleUpdateAvailable: "{name}: update available.",
  toolTitleReady: "{name}: ready.",
  toolTitleSignInUnknown: "{name}: sign-in status unknown.",
  toolCheckFailed: "Could not check AI tools.",
  toolUnavailable: "AI tool unavailable.",
  toolBundled: "This AI tool is bundled with Denker and updates with the app.",
  version: "Version",
  location: "Location",
  updateDenker: "Update Denker",
  terminalCommand: "Terminal command",
  checkAgain: "Check again",
  copiedSentence: "Copied.",
  copyFailed: "Could not copy. Select the text and copy it.",
  signIn: "Sign in",
  update: "Update",
  starting: "Starting…",
  signInStartFailed: "Could not start sign-in. Try again.",
  updateStartFailed: "Could not start the update. Try again.",
  signInContinueTerminal: "Continue signing in in Terminal.",
  signInFinishBrowser: "Finish signing in in your browser.",

  recordingFolder: "Recording folder",
  recordingFolderDefault: "Saved on this device",
  recordingFolderReadFailed: "Could not read the recording folder.",
  recordingFolderChange: "Change…",
  recordingFolderSaving: "Saving…",
  recordingFolderUseDefault: "Use default",
  recordingFolderHint:
    "Hold Caps Lock to record and drag to draw. Release to save. Original videos stay here. Selected frames are sent with your request.",
} as const;
